import * as React from "react";

export const IconPowerOff = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_6252_14544)">
			<path
				d="M14.9995 12.075L14.9995 7.5C14.9995 6.66667 14.1578 5.825 13.3328 5.83333V2.5L11.6661 2.5V5.83333L8.33281 5.83333V2.5H6.66615V4.56667L14.5911 12.4833L14.9995 12.075V12.075ZM13.5328 13.55L5.99948 6L5.99115 6.00833L3.31615 3.33333L2.25781 4.375L5.05781 7.175C5.03281 7.28333 4.99948 7.39167 4.99948 7.5L4.99948 12.0667L7.91615 15L7.91615 17.5H12.0828V15L12.4828 14.6L16.2078 18.3333L17.2578 17.2667L13.5328 13.55V13.55Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_6252_14544">
				<rect width="20" height="20" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
